<template>
  <component :is="tag" class="comment-details">
    <v-layout row wrap align-baseline>
      <v-flex xs12 class="comment-details__comment py-0 ma-0">
        <span class="float-left">
          <v-avatar
            size="32"
            v-if="
              comment.user.media &&
                comment.user.media.length &&
                comment.user.media[0].url
            "
          >
            <img :src="comment.user.media[0].url" />
          </v-avatar>
          <v-avatar class="avatar-style" size="32"  v-else>
            <span class="black--text">{{
              comment.user | initial
            }}</span>
          </v-avatar>
        </span>
        <span class="comment__metadata pl-2">
          <strong class="author-name">{{ author }}</strong>  <br />
          <span class="comment-timestamp" :title="comment.updatedAt">{{
            formattedTimestamp
          }}</span>
        </span>
        <comments-action-menus
          :comment="comment"
          :isAuthor="isAuthor"
          :isAdminUser="isAdminUser"
          :newsfeedId="newsfeedId"
        ></comments-action-menus>
      </v-flex>

      <v-flex xs12 class="comment-details__comment py-0">
        <span class="comment-details__comment float-left">{{
          comment.description
        }}</span>
      </v-flex>
      <v-flex xs12 class="py-0">
        <div
          class="comment-details__button float-left"
          v-if="
            isUserLoggedIn && activeReply_ !== comment.id && !comment.parentId
          "
          @click.stop="
            handleReplyClick(comment._id), (showCommentForm = !showCommentForm)
          "
        >
          <img src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1662449079700.svg" alt="Replay" /> Reply
        </div>
        <div
          class="comment-details__button float-right"
          :style="isUserLoggedIn ? 'cursor: pointer;' : 'cursor: default'"
          @click="
            isUserLoggedIn
              ? responseAction(
                  comment,
                  comment.status === 'dislike'
                    ? comment.status
                      ? 'remove'
                      : 'dislike'
                    : 'dislike'
                )
              : false
          "
        >
          <img
            v-if="isUserLoggedIn && comment.status === 'dislike'"
            src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1662449277215.svg"
            alt="Dislik"
          />
          <img v-else src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1662449309873.svg"  alt="Dislik" />
          <span class="digit-cls" :id="`dislike_${comment._id}`">
            {{ abbreviateNumber(comment.disLikesCount) }}
          </span>
        </div>
        <div
          class="comment-details__button float-right"
          :style="isUserLoggedIn ? 'cursor: pointer;' : 'cursor: default'"
          @click="
            isUserLoggedIn
              ? responseAction(
                  comment,
                  comment.status === 'like'
                    ? comment.status
                      ? 'remove'
                      : 'like'
                    : 'like'
                )
              : false
          "
        >
          <img
            v-if="isUserLoggedIn && comment.status === 'like'"
            src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1662449213878.svg"
            alt="Like"
          />
          <img v-else src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1662449189931.svg" alt="Like" />
          <span class="digit-cls mr-2" :id="`like_${comment._id}`">
            {{ abbreviateNumber(comment.likesCount) }}
          </span>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-btn
          text
          v-if="
            !showReplayList && comment.commentsCount > 0 && !showCommentForm
          "
          @click="
            commentResponses();
            showReplayList = true;
          "
          class="comment-reply-btn comment-details__children"
          ref="showRepliesBtn"
        >
          {{ comment.commentsCount > 0 ? comment.commentsCount : 0 }} Reply
        </v-btn>
        <div v-if="showCommentForm">
          <comment-form
            :parent="comment"
            :formAction="formAction"
            @input="$emit('input', $event)"
            @saved="activeReply_ = null"
            class="flex xs12 comment-details__reply"
            v-if="activeReply_ === comment._id"
            :ref="'commentReplyForm_' + comment._id"
            v-bind="{
              commentableId: comment.commentable_id,
              commentableType: comment.commentable_type
            }"
            @newsfeedEdited="getUpdatedComment"
            :inputField="'reply'"
            @updateResponseList="getupdatedList"
          />
        </div>
      </v-flex>
      <ul
        v-if="
          showReplayList &&
            commentResponseList[parentId] &&
            commentResponseList[parentId].length > 0
        "
        class="comment-details__children flex xs12"
      >
        <v-btn
          text
          @click="
            commentResponses();
            showReplayList = false;
          "
          class="comment-reply-btn hide-reply-btn pa-0"
          ref="hideRepliesBtn"
        >
          Hide replies
        </v-btn>
        <div
          v-if="
            commentResponseList[parentId] &&
              commentResponseList[parentId].length > 0
          "
        >
          <comments-list
            :ref="'commentlist_' + parentId"
            :name="[$options.name, childComment._id].join('_')"
            :key="[$options.name, childComment._id].join('_')"
            :activeReply.sync="activeReply_"
            :newCommentMap.sync="newCommentMap_"
            @input="$emit('input', $event)"
            showReplies
            v-bind="{ comment: childComment, isReadOnly }"
            v-for="childComment in commentResponseList[parentId]"
          />
        </div>
      </ul>
    </v-layout>
  </component>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { NewsFeedService } from "@/services";

export default {
  name: "comments-list",
  props: {
    comment: {
      type: Object /** @type {Comment} */,
      required: true
    },
    showReplies: {
      type: Boolean,
      default: false
    },
    isReadOnly: Boolean,
    activeReply: {
      type: [String, Number, Boolean],
      default: false
    },
    newCommentMap: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    commentForm: () => import("./CommentForm"),
    CommentsActionMenus: () => import("./CommentsActionMenus")
  },
  computed: {
    parentId() {
      return this.comment.parentId ? this.comment.parentId : this.comment._id;
    },
    /**
     * @returns {string}
     */
    tag() {
      return this.showReplies ? "li" : "div";
    },

    /**
     * Get the comment timestamp, formatted as a relative date
     * @returns {string}
     */
    formattedTimestamp() {
      return moment(this.comment.updatedAt).fromNow();
    },

    /**
     * Prevent mutating state by using a instance of `activeReply`, and emit any changes.
     * @returns {number}
     * @see this.activeReply
     */
    activeReply_: {
      get() {
        if (
          this.newCommentMap.findIndex(
            comment => comment._id === `tmp_${this.comment._id}`
          ) !== -1
        ) {
          return this.comment._id;
        }

        return this.activeReply;
      },
      set(parentId) {
        if (this.activeReply === parentId) return;

        // Remove the discarded comment
        let newCommentMapClone = this.newCommentMap.slice();
        let previousReplyIndex = newCommentMapClone.findIndex(
          comment => comment._id === `tmp_${this.activeReply}`
        );
        newCommentMapClone.splice(previousReplyIndex, 1);
        this.$emit("update:newCommentMap", newCommentMapClone);

        // Emit the new active reply
        this.$emit("update:activeReply", parentId);
      }
    },

    /**
     * Prevent mutating state by using a instance of `newCommentMap`, and emit any changes.
     * @returns {Array}
     * @see this.newCommentMap
     */
    newCommentMap_: {
      get() {
        return this.newCommentMap;
      },
      set(newCommentMap) {
        this.$emit("update:newCommentMap", newCommentMap);
      }
    },
    ...mapGetters({
      user: "user/user",
      newsfeedId: "newsFeedsComment/newsFeedId",
      isUserLoggedIn: "user/isUserLoggedIn"
    }),
    isAdminUser() {
      return this.isUserLoggedIn &&
        (this.user.userType == "admin" || this.user.userType == "super")
        ? true
        : false;
    },
    isAuthor() {
      return this.isUserLoggedIn &&
        this.comment.user &&
        this.comment.user._id == this.user._id
        ? true
        : false;
    },
    author() {
      return this.comment.user
        ? this.comment.user.firstName + " " + this.comment.user.lastName
        : "No Author";
    }
  },
  watch: {
    showReplies(val) {
      this.showReplayList = val;
    }
  },
  data() {
    return {
      showReplayList: false,
      formAction: "addComment",
      commentResponseList: [],
      innerResponseList: [],
      showCommentForm: false
    };
  },
  methods: {
    abbreviateNumber(number) {
      let SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
      var tier = (Math.log10(Math.abs(number)) / 3) | 0;
      if (tier == 0) return number;
      var suffix = SI_SYMBOL[tier];
      var scale = Math.pow(10, tier * 3);
      var scaled = number / scale;
      return scaled % 1 != 0 ? scaled.toFixed(1) + suffix : scaled + suffix;
    },
    async updateDeleted(data) {
      let removeId = data.id;
      let commentToRemove = "";
      if (
        this.$parent.commentResponseList &&
        this.$parent.commentResponseList[data.parentId] &&
        this.$parent.commentResponseList[data.parentId].length > 0
      ) {
        commentToRemove = this.$parent.commentResponseList[data.parentId].find(
          x => x._id === removeId
        );
        let commentIndex = this.$parent.commentResponseList[
          data.parentId
        ].indexOf(commentToRemove);
        if (commentIndex > -1) {
          this.$parent.commentResponseList[data.parentId].splice(
            commentIndex,
            1
          );
          if (this.$parent.comment.commentsCount == 0)
            this.$parent.showReplayList = false;
        }
      } else {
        this.$emit("updateComments");
      }
    },
    async getupdatedList(data) {
      const commentResponses = await NewsFeedService.getNewsFeedComments({
        parentId: data.parentId,
        newsFeedId: data.newsFeedId,
        skip: this.skip,
        limit: this.limit
      });
      if (commentResponses) {
        this.$set(
          this.commentResponseList,
          data.parentId,
          commentResponses.data.data
        );
      }
    },
    handleReplyClick(commentId) {
      this.formAction = "addComment";
      this.activeReply_ = commentId;
      this.$nextTick(function() {
        if (this.$refs["commentReplyForm_" + commentId]) {
          this.$refs[
            "commentReplyForm_" + commentId
          ].$refs.commentForm.hidden = false;
          this.$refs["commentReplyForm_" + commentId].$refs.input.focus();
        }
      });
    },
    handleEditClick(commentId) {
      this.showCommentForm = true;
      this.activeReply_ = commentId;
      this.formAction = "editComment";

      this.$nextTick(function() {
        if (this.$refs["commentReplyForm_" + commentId]) {
          this.$refs[
            "commentReplyForm_" + commentId
          ].$refs.commentForm.hidden = false;
          this.$refs["commentReplyForm_" + commentId].$refs.input.focus();
        }
      });
    },
    async commentResponses(pId = null) {
      this.commentResponseList = [];
      if (typeof this.newsfeedId == "undefined") {
        this.newsfeedId = this.$route.params.id;
      }
      let parentId = pId != null ? pId : this.comment._id;

      const commentResponses = await NewsFeedService.getNewsFeedComments({
        parentId: parentId,
        newsFeedId: this.newsfeedId,
        skip: this.skip,
        limit: this.limit
      });
      if (commentResponses && commentResponses.data.data.length > 0) {
        this.$set(
          this.commentResponseList,
          parentId,
          commentResponses.data.data
        );
      } else {
        this.showReplayList = false;
      }
    },
    async responseAction(comment, action) {
      const response = await NewsFeedService.responseAction({
        newsFeedCommentId: comment._id,
        status: action
      });
      if (response) {
        let responseData = response.data.data[0];
        comment.likesCount = responseData.likesCount;
        comment.disLikesCount = responseData.disLikesCount;
        comment.status = responseData.status;
      }
    },
    getUpdatedComment(commentData) {
      if (commentData.parentId) {
        this.comment.description = commentData.description;
      } else {
        this.$emit("updateCommentData", commentData);
      }
    }
  }
};
</script>

<style scoped>
.comment-details {
  margin: 10px 0;
  padding-left: 10px;
  list-style: none;
  /* border-left: 2px solid #eee; */
}

.comment__metadata {
  display: block;
  color: gray;
  margin-bottom: 5px;
  font-size: 12px;
  float: left;
}

.comment-details__children {
  /* margin-left: 10px !important; */
  border-left: 2px solid #eee;
}

.comment-details__button {
  display: block;
  color: #677c95;
  font-size: 12px;
  margin: 5px 0;
  padding: 0;
  border: 0;
  cursor: pointer;
}
.author-name {
  font-size: 14px;
  font-weight: 500;
  color: #27445b;
}
.comment-timestamp {
  color: #9e9e9e;
}
.comment-reply-btn {
  color: #677c95;
  font-size: 12px;
  font-style: normal;
  text-transform: capitalize;
}
.hide-reply-btn {
  top: -15px;
}
.like-button {
  padding-left: 89px;
}
.avatar-style {
  background-color: rgb(252, 252, 252);
  border: 1px solid #d6e0ef !important;
  border-color: rgb(252, 252, 252);
}
</style>
